<template>
  <div class="header-container">
    <div class="logo"></div>
    <ul class="nav">
      <li v-for="(item, i) in nav" :key="i">
        {{ item.name }}
        <a :href="item.link"></a>
      </li>

      <div class="media-dropdown">
        <div class="holder">
          {{ socials.name }}
          <div class="icon"></div>
        </div>
        <ul class="dropdown-list">
          <div class="inner">
            <li v-for="(item, i) in socials.list" :key="i" :name="item.name">
              {{ item.name }}
              <div v-if="item.img" class="QR-code-box">
                <div class="QR-code" :style="{ 'background-image': `url(${item.img})` }"></div>
              </div>
              <a v-else :href="item.link" target="_blank"></a>
            </li>
          </div>
        </ul>
      </div>
    </ul>

    <div class="right-side">

      <div v-if="shop.link" class="btn-entry red shop shop-btn-mobile">
        <a :href="shop.link" target="_blank">
          {{ shop.name }}
          <div class="icon"></div>
        </a>
        <div v-if="discountVisible" class="discount-tag">
          <img :src="discountTagPC" />
          <img v-if="discountMark" class="discount-mark" :src="discountMark" />
        </div>
      </div>

      <div class="switch-locale">
        <div class="holder">
          <div class="icon"></div>
        </div>
        <ul class="locales-list">
          <div class="inner">
            <li v-for="(item, i) in langs" :key="i" >
              {{ item.label }}
              <a :href="item.link"></a>
            </li>
          </div>
        </ul>
      </div>

      <div v-if="shop.link" class="btn-entry red shop">
        <a :href="shop.link" target="_blank">
          {{ shop.name }}
          <div class="icon"></div>
        </a>
        <div v-if="discountVisible" class="discount-tag">
          <img :src="discountTagPC" />
          <img v-if="discountMark" class="discount-mark" :src="discountMark" />
        </div>
      </div>

      <div v-if="downloadLink" class="btn-entry yellow download">
        <a :href="downloadLink" target="_blank" download="true">
          {{ download.name }}
          <div class="icon"></div>
        </a>
      </div>


      <div class="nav-app">
        <div class="holder">
          <div class="icon"></div>
        </div>
        <ul class="nav-app-list">
          <div class="inner">
            <li v-for="(item, i) in nav" :key="i">
              {{ item.name }}
              <a :href="item.link"></a>
            </li>

            <li v-if="shop.link">
              {{ shop.name }} <img v-if="discountVisible" class="discount-tag-mobile" :src="discountTagMobile" />
              <a :href="shop.link" target="_blank"></a>
            </li>
            <li v-if="downloadLink">
              {{ download.name }}
              <a :href="downloadLink" target="_blank" download="true"></a>
            </li>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { os } from './os.js'

export default {
  props: {
    lang: {
      type: String,
      default: 'en_US',
    },
    isOversea: {
      type: Boolean,
      default: true,
    },
    nav: {
      type: Array,
      default: () => {
        return [
          {
            name: 'HOME',
            link: 'https://torchlight.xd.com/en/index'
          },
          {
            name: 'NEWS',
            link: 'https://torchlight.xd.com/en/news/list'
          },
          {
            name: 'WIKI',
            link: 'https://tlidb.com/en/'
          },
          {
            name: 'SEASON',
            link: 'https://torchlight.xd.com/en/ep2'
          },
          {
            name: 'DATA',
            link: 'https://torchlight.xd.com/en/data'
          }
        ]
      }
    },
    socials: {
      type: Object,
      default: () => {
        return {
          name: 'OUR SOCIALS',
          list: [
            {
              name: 'Twitter',
              link: 'https://twitter.com/torchlight_xd'
            }, 
            {
              name: 'Facebook',
              link: 'https://www.facebook.com/torchlightinfinite.global'
            }, 
            {
              name: 'Discord',
              link: 'https://discord.com/invite/torchlight'
            }, 
            {
              name: 'YouTube',
              link: 'https://www.youtube.com/channel/UCQqnkC2MHPZZdRX4dhAAwgQ'
            }, 
            {
              name: 'Twitch',
              link: 'https://www.twitch.tv/torchlight_infinite'
            }, 
            {
              name: 'TapTap',
              link: 'https://www.taptap.io/app/227017'
            }
          ]
        }
      }
    },
    langs: {
      type: Array,
      default: () => {
        return [
          {
            label: '中文 (简体)',
            code: 'zh-cn',
            link: ''
          },
          {
            label: '中文 (繁體)',
            code: 'zh-tw',
            link: ''
          },
          {
            label: 'English',
            code: 'en',
            link: ''
          },
          {
            label: '日本語',
            code: 'jp',
            link: ''
          },
          {
            label: '한국어',
            code: 'kr',
            link: ''
          }
        ]
      }
    },
    shop: {
      type: Object,
      default: () => {
        return {
          name: 'SHOP',
          link: 'https://torchlight.xd.com/webpay?lang=en_US'
        }
      }
    },
    download: {
      type: Object,
      default: () => {
        return {
          name: 'DOWNLOAD',
          link: {
            ios: 'https://apps.apple.com/app/torchlight-infinite/id1593130084',
            android: 'https://play.google.com/store/apps/details?id=com.xd.TLglobal',
            pc: 'https://torchlight-northamerica.torchlight.xd.com/ReleaseGlobal/Windows/TorchlightSetup_PC.1.0.1.5.exe'
          }
        }
      }
    },
    '__INTRO__': {
      type: String,
      default: () => '介绍文档: https://xindong.atlassian.net/wiki/spaces/PlatformDivision/pages/667653093'
    }
  },

  data() {
    return {
      discountVisible: false,
      downloadLink: '',
      discountTagPC: '',
      discountTagMobile: '',
      discountMark: '',
    }
  },

  watch: {
    download: {
      handler(newVal, oldVal) {
        if(newVal && newVal != oldVal) {
          // 使用动态数据源
          if (newVal.dynamic && newVal.dynamic.url) {
            this.getDynamicData(newVal.dynamic)
            return;
          }
          this.setDownloadLink(newVal.link['ios'], newVal.link['android'], newVal.link['pc']);
        }
      },
      immediate: true,
      deep: true
    }
  },

  mounted() {
    this.getPageInfo();
  },

  methods: {
    getDynamicData({ url, ios, android, other }) {
      fetch(url + '?timestamp=' + Date.now())
        .then((res) => res.json())
        .then((data) => {
          const iosLink = this.getPropInObj(data, ios)
          const androidLink = this.getPropInObj(data, android)
          const otherLink = this.getPropInObj(data, other)
          this.setDownloadLink(iosLink, androidLink, otherLink)
        })
        .catch(() => {})
    },

    getPropInObj(target, prop) {
      const props = prop.split('.');
      try {
        let result = target;
        for (const item of props) {
          result = result[item];
        }
        return result;
      } catch {
        return;
      }
    },

    setDownloadLink(ios, android, other) {
      if(os.isIPhone || os.isIpad || os.isMac) {
        this.downloadLink = ios
      }else if(os.isAndroid) {
        this.downloadLink = android
      }else {
        this.downloadLink = other
      }
    },

    isEmpty(target) {
      return target === undefined || target === '' || target === null;
    },

    getProp(target, prop) {
      try {
        let props = (prop + '').split('.');
        let result = target;
        for (const item of props) {
          if (this.isEmpty(result)) return '';
          result = Reflect.get(result, item);
        }
        return result;
      } catch (e) {
        return '';
      }
    },

    getPageInfo() {
      let pageInfoUrl = 'https://website.xdcdn.net/form/website/common-config/common_172664.json';
      if (this.isOversea) {
        pageInfoUrl = 'https://website.xdcdn.net/form/website/common-config/common_227017.json';
      }
      fetch(pageInfoUrl + '?t=' + Date.now())
        .then((res) => res.json())
        .then((data) => {
          this.discountVisible = this.getProp(data, '__default.chargeTag.show');
          const localePcBg = this.getProp(data, this.lang + '.chargeTag.pcBg.url');
          if (localePcBg) {
            this.discountTagPC = localePcBg;
          } else {
            this.discountTagPC = this.getProp(data, '__default.chargeTag.pcBg.url');
          }

          const localeMobileBg = this.getProp(data, this.lang + '.chargeTag.mobileBg.url');
          if (localeMobileBg) {
            this.discountTagMobile = localeMobileBg;
          } else {
            this.discountTagMobile = this.getProp(data, '__default.chargeTag.mobileBg.url');
          }

          const localeDiscountMark = this.getProp(data, this.lang + '.chargeTag.mark.url');
          if (localeDiscountMark) {
            this.discountMark = localeDiscountMark;
          } else {
            this.discountMark = this.getProp(data, '__default.chargeTag.mark.url');
          }
        })
        .catch(() => {});
    },
  },
}
</script>

<style lang="scss" scoped>
@function vwPc($px) {
  @return calc($px / 1920px) * 100vw;
};
a {
  text-decoration: none;
}

.header-container {
  position: relative;
  width: 100%;
  height: vwPc(60px);
  background-color: #060A14;
  font-family: Arial,sans-serif;
  .logo {
    position: absolute;
    width: vwPc(47.5px);
    height: vwPc(43.5px);
    background-image: url('https://website.xdcdn.net/homepage/torchlight/imgs/pc/header/logo_2x.png');
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    margin: 0.45vw 0 0 0.625vw;
  }

  .nav {
    position: absolute;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    color: #ababab;
    height: 100%;
    font-weight: 700;
    margin-left: vwPc(100px);
    font-size: vwPc(18px);
    li {
      padding: 0 0.10417vw;
      height: 100%;
      line-height: 3.125vw;
      margin: 0 vwPc(15px);
      text-align: center;
      color: #ababab;
      letter-spacing: 0.1px;
      transition: all ease-in-out 200ms;
      position: relative;
      cursor: pointer;
      white-space: nowrap;
      a {
        position: absolute;
        display: inline-block;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }

      &::before {
        content: "";
        width: 100%;
        height: 1px;
        background-color: #ffb833;
        position: absolute;
        left: 0;
        bottom: 0.625vw;
        opacity: 0;
        transition: all ease-in-out 200ms;
      }

      &:hover {
        color: #fff;
      }
      &.active {
        color: #ffb833;
        &::before {
          opacity: 1;
        }
      }
      &.isHide {
        display: none;
      }
    }
  }


  .media-dropdown {
    position: relative;
    margin-left: vwPc(11px);
    &:hover {
      .dropdown-list {
        opacity: 1;
        visibility: visible;
      }
    }
    .holder {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
      color: #ababab;
      letter-spacing: 0.1px;
      font-weight: 700;
      font-size: vwPc(18px);
      display: flex;
      align-items: center;
      height: 100%;
      line-height: 3.125vw;
      .icon {
        width: vwPc(12px);
        height: vwPc(5px);
        background-image: url('https://website.xdcdn.net/homepage/torchlight/imgs/overseas/add2022/arrow.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        margin-left: 0.18229vw;
        &:hover {
          background-image: url('https://website.xdcdn.net/homepage/torchlight/imgs/overseas/add2022/arrow.png');
        }
      }
    }
    .dropdown-list {
      position: absolute;
      width: vwPc(164px);
      top: vwPc(54px);
      left: 50%;
      margin-left: vwPc(-0.5 * 164px);
      opacity: 0;
      visibility: hidden;
      padding-top: vwPc(10px);
      .inner {
        background-color: rgba(8, 15, 26, 0.9);
        border-radius: 3px;
        font-size: 14px;
        padding: 10px 0;
      }
      li {
        position: relative;
        height: 35px;
        line-height: 35px;
        color: #ABABAB;
        padding-left: vwPc(15px);
        padding-right: vwPc(15px);
        white-space: nowrap;
        cursor: pointer;
        transition: all ease-in-out 200ms;
        a {
          display: inline-block;
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
        &:hover {
          color: #fff;
        }

        &.active {
          color: #ffc221;
        }

        &:hover {
          .QR-code-box {
            opacity: 1;
            visibility: visible;
          }
        }

        .QR-code-box {
          position: absolute;
          top: vwPc(-10px);
          left: vwPc(158px);
          width: vwPc(120px);
          height: vwPc(120px);
          background-color: rgba(8, 15, 26, 0.9);
          border-radius: vwPc(3px);
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          visibility: hidden;
          .QR-code {
            width: vwPc(89px);
            height: vwPc(89px);
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
          }
        }
      }
    }
  }

  .right-side {
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-items: center;
    align-items: center;
  }

  .switch-locale {
    position: relative;
    height: 100%;
    margin-right: vwPc(25px);
    &:hover {
      .locales-list {
        opacity: 1;
        visibility: visible;
      }
    }
    .holder {
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
      .icon {
        width: vwPc(40px);
        height: vwPc(31px);
        background-image: url('https://website.xdcdn.net/homepage/torchlight/imgs/overseas/add2022/icon_locale.png');
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        &:hover {
          background-image: url("https://website.xdcdn.net/homepage/torchlight/imgs/overseas/add2022/icon_locale_active.png");
        }
      }
    }
    .locales-list {
      position: absolute;
      top: vwPc(54px);
      left: 50%;
      transform: translate3d(-50%, 0, 0);
      list-style: none !important;
      padding-top: vwPc(10px);
      opacity: 0;
      visibility: hidden;
      .inner {
        background-color: rgba(8, 15, 26, 0.9);
        border-radius: 3px;
        font-size: 14px;
        padding: 10px 0;
      }
      li {
        position: relative;
        height: 31px;
        line-height: 31px;
        color: #ABABAB;
        padding-left: 15px;
        padding-right: 20px;
        white-space: nowrap;
        cursor: pointer;
        transition: all ease-in-out 200ms;
        list-style: none !important;
        font-weight: 500;
        &:hover {
          color: #fff;
        }
        &.active {
          color: #ffc221;
        }

        a {
          position: absolute;
          display: inline-block;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
      }
    }
  }

  .btn-entry {
    height: vwPc(40px);
    border-radius: vwPc(8px);
    a {
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: center;
      padding: 0 vwPc(20px) 0 vwPc(22.5px);
      font-size: vwPc(16px);
      color: #291A09;
      font-weight: bolder;
      font-family: 'Source Han Sans CN';
      .icon {
        width: vwPc(7px);
        height: vwPc(9px);
        background-image: url('https://website.xdcdn.net/homepage/torchlight/imgs/domestic/arrow.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        margin-left: vwPc(3.5px);
      }
    }

    &.red {
      background: linear-gradient(180deg, #EF421C 0%, #EF811C 100%);
      box-shadow: inset 0px vwPc(-2px) 0px #EFA71C;
    }
    &.yellow {
      background: linear-gradient(180deg, #FD7317 -20.38%, #FFC220 42.36%);
      box-shadow: inset 0px vwPc(-2px) 0px #FFDC7D;
    }
    &:hover {
      opacity: 0.9;
    }
  }

  .download {
    margin-right: vwPc(90px);
  }
  .shop {
    position: relative;
    margin-right: vwPc(25px);
  }
  .discount-tag {
    left: 50%;
    width: 10vw;
    height: auto;
    margin-top: 1vw;
    position: absolute;
    transform: translateX(-50%);

    img {
      width: 100%;
      height: auto;
    }
    .discount-mark {
      width: 2.7vw;
      height: auto;
      position: absolute;
      top: -4.5vw;
      left: 6.5vw;
    }
  }

  .nav-app {
    display: none;
  }

  .shop-btn-mobile {
    display: none;
  }
}


@media screen and (max-width: 1920px) {
.header-container {
  height: 60px;
  .logo {
    width: 47.5px;
    height: 43.5px;
    margin: 8.65px 0 0 12px;
  }

  .nav {
    margin-left: 100px;
    font-size: 18px;
    li {
      padding: 0 4px;
      line-height: 60px;
      margin: 0 13px;
    }
  }


  .media-dropdown {
    margin-left: 11px;

    .holder {
      font-size: 18px;
      line-height: 60px;
      .icon {
        width: 12px;
        height: 5px;
        margin-left: 3.5px;
      }
    }
    .dropdown-list {
      width: 164px;
      top: 54px;
      margin-left: -0.5 * 164px;
      padding-top: 10px;
      .inner {
        border-radius: 3px;
        font-size: 14px;
        padding: 10px 0;
      }
      li {
        height: 35px;
        line-height: 35px;
        padding-left: 15px;
        padding-right: 15px;
        .QR-code-box {
          top: -10px;
          left: 158px;
          width: 120px;
          height: 120px;
          border-radius: 3px;
        }
      }
    }
  }

  .switch-locale {
    margin-right: 25px;
    .holder {
      .icon {
        width: 40px;
        height: 31px;
      }
    }
    .locales-list {
      top: 54px;
      padding-top: 10px;
      .inner {
        border-radius: 3px;
        font-size: 14px;
        padding: 10px 0;
      }
      li {
        height: 31px;
        line-height: 31px;
        padding-left: 15px;
        padding-right: 20px;
      }
    }
  }

  .btn-entry {
    height: 40px;
    border-radius: 8px;
    a {
      padding: 0 20px 0 22.5px;
      font-size: 16px;
      .icon {
        width: 7px;
        height: 9px;
        margin-left: 3.5px;
      }
    }
  }

  .download {
    margin-right: 90px;
  }
  .shop {
    margin-right: 25px;
  }
}
}

@function vwPc_1600($px) {
  @return calc($px / 1600px) * 100vw;
};
@media screen and (max-width: 1600px) {
.header-container {
  height: vwPc_1600(60px);
  .logo {
    width: vwPc_1600(47.5px);
    height: vwPc_1600(43.5px);
    margin: vwPc_1600(8.64px) 0 0 vwPc_1600(12px);
  }

  .nav {
    margin-left: vwPc_1600(100px);
    font-size: vwPc_1600(18px);
    li {
      padding: 0 vwPc_1600(4px);
      line-height: vwPc_1600(60px);
      margin: 0 vwPc_1600(13px);
    }
  }


  .media-dropdown {
    margin-left: vwPc_1600(11px);

    .holder {
      font-size: vwPc_1600(18px);
      line-height: vwPc_1600(60px);
      .icon {
        width: vwPc_1600(12px);
        height: vwPc_1600(5px);
        margin-left: vwPc_1600(3.5px);
      }
    }
    .dropdown-list {
      width: vwPc_1600(164px);
      top: vwPc_1600(54px);
      margin-left: vwPc_1600(-0.5 * 164px);
      padding-top: vwPc_1600(10px);
      .inner {
        border-radius: vwPc_1600(3px);
        font-size: vwPc_1600(14px);
        padding: vwPc_1600(10px) 0;
      }
      li {
        height: vwPc_1600(35px);
        line-height: vwPc_1600(35px);
        padding-left: vwPc_1600(15px);
        padding-right: vwPc_1600(15px);
        .QR-code-box {
          top: vwPc_1600(-10px);
          left: vwPc_1600(158px);
          width: vwPc_1600(120px);
          height: vwPc_1600(120px);
          border-radius: vwPc_1600(3px);
        }
      }
    }
  }

  .switch-locale {
    margin-right: vwPc_1600(25px);
    .holder {
      .icon {
        width: vwPc_1600(40px);
        height: vwPc_1600(31px);
      }
    }
    .locales-list {
      top: vwPc_1600(54px);
      padding-top: vwPc_1600(10px);
      .inner {
        border-radius: vwPc_1600(3px);
        font-size: vwPc_1600(14px);
        padding: vwPc_1600(10px) 0;
      }
      li {
        height: vwPc_1600(31px);
        line-height: vwPc_1600(31px);
        padding-left: vwPc_1600(15px);
        padding-right: vwPc_1600(20px);
      }
    }
  }

  .btn-entry {
    height: vwPc_1600(40px);
    border-radius: vwPc_1600(8px);
    a {
      padding: 0 vwPc_1600(20px) 0 vwPc_1600(22.5px);
      font-size: vwPc_1600(16px);
      .icon {
        width: vwPc_1600(7px);
        height: vwPc_1600(9px);
        margin-left: vwPc_1600(3.5px);
      }
    }
  }

  .download {
    margin-right: vwPc_1600(90px);
  }
  .shop {
    margin-right: vwPc_1600(25px);
  }
}
}


@function vwApp($px) {
  @return calc($px / 750px) * 100vw;
};
@media screen and (max-width: 828px) {
.header-container {
  height: vwApp(75px);
  .nav, .btn-entry {
    display: none;
  }

  .shop-btn-mobile {
    display: block;
    height: vwApp(50px);
    margin-right: vwApp(24px) !important;
    a {
      padding: 0 vwApp(24px) 0 vwApp(30px);
      font-size: vwApp(26px);
      .icon {
        width: vwApp(10px);
        height: vwApp(10px);
        margin-left: vwApp(8px);
      }
    }
    .discount-tag {
      width: 28vw;
      margin-top: 3vw;
      .discount-mark {
        width: 8vw;
        height: auto;
        position: absolute;
        top: -12.5vw;
        left: 19.5vw;
      }
    }
  }

  .logo {
    width: vwApp(55px);
    height: vwApp(55px);
    background-image: url('https://website.xdcdn.net/homepage/torchlight/imgs/mobile/header/logo.png');
    margin: vwApp(12px) 0 0 vwApp(15px);
  }

  .switch-locale {
    margin-right: vwApp(30px);
    .holder {
      .icon {
        width: vwApp(40px);
        height: vwApp(31px);
        background-image: url("https://website.xdcdn.net/homepage/torchlight/imgs/overseas/add2022/icon_locale_active.png");
      }
    }
    .locales-list {
      width: vwApp(300px);
      top: vwApp(68px);
      left: 50%;
      transform: translate3d(-50%, 0, 0);
      padding-top: vwApp(10px);
      max-height: 70vh;
      overflow-x: hidden;
      overflow-y: scroll;
      .inner {
        background-color: #000;
        border-radius: vwApp(5px);
        font-size: vwApp(28px);
        padding: vwApp(20px) 0;
      }
      li {
        height: vwApp(62px);
        line-height: vwApp(62px);
        color: #fff;
        padding-left: vwApp(30px);
        padding-right: vwApp(6px);
        &:hover {
          background-color: #ffc221;
        }

        &.active {
          background-color: #ffc221;
        }
      }
    }
  }

  .nav-app {
    position: relative;
    height: 100%;
    display: block;
    margin-right: vwApp(45px);
    &:hover {
      .nav-app-list {
        opacity: 1;
        visibility: visible;
      }
    }
    .holder {
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
      .icon {
        width: vwApp(48px);
        height: vwApp(48px);
        background-image: url('https://website.xdcdn.net/homepage/torchlight/imgs/mobile/header/more.png');
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        &:hover {
          background-image: url("https://website.xdcdn.net/homepage/torchlight/imgs/mobile/header/more_active.png");
        }
      }
    }
    .nav-app-list {
      position: absolute;
      width: vwApp(300px);
      top: vwApp(68px);
      left: 50%;
      transform: translate3d(-78%, 0, 0);
      padding-top: vwApp(10px);
      max-height: 70vh;
      overflow-x: hidden;
      overflow-y: scroll;
      opacity: 0;
      visibility: hidden;
      .inner {
        background-color: #000;
        border-radius: vwApp(5px);
        font-size: vwApp(28px);
        padding: vwApp(20px) 0;
      }
      li {
        position: relative;
        height: vwApp(62px);
        line-height: vwApp(62px);
        color: #ababab;
        // padding-right: vwApp(40px);
        white-space: nowrap;
        cursor: pointer;
        transition: all ease-in-out 200ms;
        list-style: none !important;
        font-weight: bolder;
        text-align: center;
        &:hover {
          color: #ffc221;
        }

        &.active {
          background-color: #ffc221;
        }

        a {
          position: absolute;
          display: inline-block;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
      }
    }
    .discount-tag-mobile {
      position: absolute;
      top: 0;
      width: 8vw;
      height: auto;
      left: 0;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
}
</style>